/** Parking listing photo slots — shared by web + mobile QR flow. */
export const PARKING_PHOTO_ANGLES = [
  { id: "overview", label: "Overview", hint: "Wide shot of the parking area or driveway" },
  { id: "entrance", label: "Entrance", hint: "Gate, driveway mouth, or access point" },
  { id: "spot", label: "Parking spot", hint: "Clear view of where the car will park" },
  { id: "extra", label: "Extra", hint: "Signage, lighting, EV charger, or security" },
];

export function parkingPhotosComplete(photos = {}) {
  return PARKING_PHOTO_ANGLES.some((a) => photos[a.id]?.file_id);
}

export function parkingPhotosToUrls(photos = {}) {
  return PARKING_PHOTO_ANGLES.filter((a) => photos[a.id]?.file_id).map(
    (a) => `/api/files/${photos[a.id].file_id}`,
  );
}

export function mergeParkingPhotoSync(prev = {}, incoming = {}) {
  const next = { ...prev };
  for (const [slot, entry] of Object.entries(incoming || {})) {
    if (entry?.file_id) next[slot] = entry;
  }
  return next;
}

/** Map existing listing image URLs into guided parking photo slots (edit flow). */
export function urlsToParkingPhotos(urls = []) {
  const photos = {};
  const list = Array.isArray(urls) ? urls : [];
  PARKING_PHOTO_ANGLES.forEach((angle, i) => {
    const raw = list[i];
    if (!raw) return;
    const m = String(raw).match(/\/(?:api\/)?files\/([a-f0-9]{32})/i);
    const fileId = m?.[1];
    if (!fileId) return;
    photos[angle.id] = { angle: angle.id, file_id: fileId, url: raw.startsWith("http") ? raw : `/api/files/${fileId}` };
  });
  return photos;
}
